module.exports = __webpack_public_path__ + "img/luza3.1b6b28f0.jpeg";